/** User-facing words for Ask AttorneyShare, shared across its surfaces. */

export const ASSISTANT_NAME = 'Ask Attorney Share'

/** Default starter questions, written the way an attorney would ask them. */
export const ASSISTANT_SUGGESTED_PROMPTS = [
  'What needs my attention?',
  'Find cases that fit my practice areas',
  'Help me post a referral',
] as const

/** The top-bar button's tooltip, its field and the field's dropdown. */
export const ASSISTANT_ASK_BAR = {
  /** With a conversation to go back to; the button keeps its name. */
  resumeTooltip: 'Continue your conversation',
  placeholder: 'Ask Attorney Share about your cases…',
  inputLabel: 'Ask Attorney Share about your cases',
  dropdownLabel: 'Ask Attorney Share suggestions',
  needsYou: 'Needs you',
  tryAsking: 'Try asking',
} as const

/** The dropdown's first option once something is typed. */
export const askOptionLabel = (question: string) => `Ask “${question}”`

/**
 * Under the message box. The design said changes "stay with you", but the
 * assistant can make them once you approve its card, so say that instead.
 */
export const ASSISTANT_DISCLAIMER =
  'Answers can be wrong. Nothing changes on a case until you approve it.'

/** What screen readers hear as a turn starts and finishes. */
export const ASSISTANT_ANNOUNCEMENTS = {
  thinking: 'Ask Attorney Share is thinking.',
  approval:
    'A change needs your OK before anything happens. Review it in the conversation.',
  ready: 'Ask Attorney Share answered.',
} as const
